import { AxiosError } from 'axios';
import * as Sentry from '@sentry/nextjs';
import useSWR from 'swr';
import { useRecoilValue } from 'recoil';
import { authState } from '@/stores/authStore';
import { authFetcher } from '@/core/http';
import { PaymentProvider, WithdrawalEligibility } from '.';
import { useUser } from '../userService';

export function useWithdrawalEligibility() {
  const { token, isGuestToken } = useRecoilValue(authState);
  const { data: user } = useUser();

  const subscriptionProvider =
    !isGuestToken &&
    !!user?.monetization.subscriptionProvider &&
    user.monetization.subscriptionProvider !== PaymentProvider.Mobile &&
    user.monetization.subscriptionProvider;

  const resp = useSWR<WithdrawalEligibility, AxiosError>(
    subscriptionProvider && token
      ? [`/${subscriptionProvider}/withdrawal/eligibility`, token]
      : null,
    authFetcher,
    {
      onError: (error) => {
        Sentry.captureException(error, {
          tags: {
            feature: 'withdrawal',
            phase: 'eligibility_fetch',
          },
          extra: {
            subscriptionProvider,
            status: error?.response?.status,
          },
        });
      },
    }
  );

  return resp;
}
